import axios from 'axios';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../context/AppContext';
import { defaultPageInfo } from '../../../interface/CommonInterface';
import { INotification } from '../../../interface/NotificationsInterface';
import { formatDateTime } from '../../../utils/dateTimeUtils';
import { addToast } from '../../../utils/toastNotifications';
import { endpoints } from '../../../utils/URL';
import Loader from '../../common/Loader';
import NoDataView from '../../common/NoData';
import Pagination from '../../common/Pagination';

const NotificationsTable = () => {
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const [pageInfo, setPageInfo] = useState(defaultPageInfo);
  const [isLoading, setLoading] = useState(false);

  const { appState } = useContext(AppContext);
  const pharmacyId: number = appState.pharmacyId;

  const getNotifications = useCallback(
    async (pageIndex: number) => {
      const url = `${endpoints.notifications.getByPharmacy}/${pharmacyId}?pageIndex=${pageIndex}&pageSize=10`;
      setLoading(true);
      try {
        const response = await axios.get(url);
        setNotifications(response.data.data);

        const responsePageInfo = {
          pageIndex: response.data.pageIndex,
          pageSize: response.data.pageSize,
          pageCount: response.data.pageCount,
        };
        //set page info
        setPageInfo(responsePageInfo);
      } catch (error) {
        addToast('An error occured', 'error');
      } finally {
        setLoading(false);
      }
    },
    [pharmacyId]
  );

  useEffect(() => {
    getNotifications(1);
  }, [getNotifications]);

  const dataView = (
    <div>
      <div className='table-responsive'>
        <table className='table table-hover table-bordered'>
          <thead>
            <tr>
              <th>Date</th>
              <th>Notification Content</th>
              <th>Read</th>
            </tr>
          </thead>
          <tbody>
            {notifications.map((notification, key) => (
              <tr key={key}>
                <td>{formatDateTime(notification.dateCreated)}</td>
                <td>{notification.notificationContent}</td>
                <td>
                  {notification.isRead ? (
                    <span className='bi bi-check'></span>
                  ) : (
                    <span className='bi bi-x'></span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPageNumber={pageInfo.pageIndex}
        numberOfPages={pageInfo.pageCount}
        callback={getNotifications}
      />
    </div>
  );

  return (
    <section className='col-md-10 content-section'>
      <h4>Notifications</h4>
      <div className='mt-4'></div>
      {isLoading && <Loader />}
      {!isLoading && notifications.length > 0 && dataView}
      {!isLoading && notifications.length === 0 && <NoDataView />}
    </section>
  );
};

export default NotificationsTable;
